// @flow
import type {Element} from 'react'
import React from 'react'

type Props = {
  title: string,
}

function ChangeTitle({title}: Props): Element<"div"> {
  return (
    <div className="proposal-summary-change-title">
      <div className="proposal-summary-change-title__text">
        {title}
      </div>
    </div>
  )
}

export default ChangeTitle
